"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAwyesContent = exports.getAllContentType = exports.checkoutOfferCode = void 0;
var checkoutOfferCode = {
  projection: "\n    query($query: AwyesCheckoutOfferCodeQuery!) {\n      checkoutOfferCode(query: $query) {\n        status\n        offerCode\n        discountAmount\n      }\n    }\n  ",
  resolverField: 'checkoutOfferCode'
};
exports.checkoutOfferCode = checkoutOfferCode;
var getAwyesContent = {
  projection: "\n    query($query: AwyesContentQuery!) {\n      getAwyesContent(query: $query) {\n        items {\n          ... on AwyesContent {\n            id\n            awyesId\n          }\n          ... on AwyesProduct {\n            name\n            code\n            price\n            wasPrice\n            images {\n              path\n              width\n              height\n            }\n          }\n          ... on AwyesPage {\n            url\n          }\n          typeName: __typename\n        }\n        notFound\n      }\n    }\n  ",
  resolverField: 'getAwyesContent'
};
exports.getAwyesContent = getAwyesContent;

var getAllContentType = function getAllContentType(_ref) {
  var typeName = _ref.typeName,
      additionalFields = _ref.additionalFields;
  return {
    projection: "\n    query($query: AwyesContentAllQuery!) {\n      getAll".concat(typeName, "(query: $query) {\n        nextToken\n        items {\n          ... on AwyesContent {\n            id\n            awyesId\n            hidden\n            revision\n            updatedDate\n            createdDate\n          }\n          ... on AwyesPage {\n            url\n          }\n          typeName: __typename\n          ").concat(additionalFields !== null && additionalFields !== void 0 && additionalFields.length ? "... on ".concat(typeName, " {\n ").concat(additionalFields.filter(Boolean).join('\n'), "\n }\n") : '', "\n        }\n      }\n    }\n  "),
    resolverField: "getAll".concat(typeName)
  };
};

exports.getAllContentType = getAllContentType;